export const PlansService = angular
    .module('app.services.data.plansService', [])
    .service('plansService', ($http) => {
        function getPlans() {
            return $http.get(`${process.env.BASE_API_URL}/plans`)
                .then(response => response.data);
        }

        return {
            getPlans
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/plans.service.js